var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "search_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4991",
  fill: "currentColor",
  d: "M0 0h40v40H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33367",
  clipPath: "url(#search_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13099",
  d: "m39.512 37.155-13.4-13.4a14.686 14.686 0 1 0-2.357 2.357l13.4 13.4a1.666 1.666 0 1 0 2.357-2.357M3.333 14.653a11.32 11.32 0 1 1 11.319 11.32 11.332 11.332 0 0 1-11.319-11.32",
  fill: "currentColor"
}))));
export default SvgSearch;